import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { Alert } from "@mui/material";
import {
  hideMessage,
  showAuthLoader,
  userSignIn
} from "actions/Auth";
import CardBox from "components/CardBox";
import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { isIOS, isMobile } from "react-device-detect";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import IntlMessages from "util/IntlMessages";
import { getItemReviewByCorrectionCodeApi } from "../api/itemReview";
import { getDateLocale2 } from "../util/utilFunction";


class ItemReviewCorrect extends React.Component {
  constructor() {
    super();
    this.state = {
      itemReview: {},
      lock: true,
      error:false,
    };
  }

  async componentDidMount() {
    const paramsString = this.props.location.search;
    const params = new URLSearchParams(paramsString);
    const cd = params.get("cd");

    if(cd.length>4) 
    {

      const result = await getItemReviewByCorrectionCodeApi(cd);
     //console.log("resut ",result)
      if(result.status)
      {
        if (result.data.length>0) 
        {
          this.setState({ lock: false , itemReview:result.data[0]});
        }
       
      }

    }

    // const result = await getItemByUidApi(uid);
    // if (result.status) {
    // // //console.log("444444444444444 ", result);
    //   this.setState({ item: result.data.item, process: result.data.process });
    // }


  }


  getResultByCorrectCode = async(correctCode) =>{

    const result = await getItemReviewByCorrectionCodeApi(correctCode);
   //console.log("resut ",result)
    if(result.status)
    {
      if (result.data.length>0) 
      {
        this.setState({ lock: false , itemReview:result.data[0]});
      }
      else 
      this.setState({error:true})
    }


  }

  render() {
    const { itemReview, lock } = this.state;

    if (isIOS || isMobile) {
      document.body.classList.add("ios-mobile-view-height");
   //  //console.log("--------------------------------------------- ",isIOS, isMobile)
    } else if (document.body.classList.contains("ios-mobile-view-height")) {
   //  //console.log("--------------------------------------------- ",isIOS, isMobile)
      document.body.classList.remove("ios-mobile-view-height");
    }

    return (
      <div className="app-wrapper">
      <div className="animated slideInUpTiny animation-duration-3">
   
   
       
            {!lock ? (
              <div className="overflow-auto">
                <div className="row justify-content-center mb-3">
                  <Link to="/">
                    <img
                      src={require("assets/images/says_logo/sonLogo2.png")}
                      alt="Yaysis"
                      title="Sözlük ve Ansiklopedi Yönetim Sistemi"
                    />
                  </Link>
                </div>

                <CardBox
                  styleName="col-md-12 col-xs-12 col-sm-12"
                  heading={<IntlMessages id="item.information" />}
                >
                  <List dense={true}>
                    <Divider light />

                    <ListItem>
                      <ListItemText
                        color="teal"
                        primary={<IntlMessages id="institution" />}
                        primaryTypographyProps={{ color: "secondary" }}
                        secondary={  <IntlMessages id={"institution."+itemReview.institution} />}
                      />
                    </ListItem>
                    <Divider light />
                    <ListItem>
                      <ListItemText
                        color="teal"
                        primary={<IntlMessages id="referee.title" />}
                        primaryTypographyProps={{ color: "secondary"  }}
                        secondaryTypographyProps={{  fontWeight:'bold' , fontSize:14}}

                        secondary={itemReview.refereeName}
                      />
                    </ListItem>
                    <Divider light />
                    <ListItem>
                      <ListItemText
                        color="teal"
                        primary={<IntlMessages id="item.title" />}
                        primaryTypographyProps={{ color: "secondary" }}
                        secondary={itemReview.title}
                      />
                    </ListItem>
                    <Divider light />
                    <ListItem>
                      <ListItemText
                        primary={<IntlMessages id="itemReview.reviewDate" />}
                        primaryTypographyProps={{ color: "secondary" }}
                        secondary={
                        getDateLocale2("tr",itemReview.reviewDate)
                        }
                      />
                    </ListItem>
                    <Divider light />
                    <ListItem>
                      <ListItemText
                        primary={<IntlMessages id="itemReview.correctionCode" />}
                        primaryTypographyProps={{ color: "secondary" }}
                        secondary={
                          itemReview.correctionCode
                        }
                      />
                    </ListItem>
                   
                    <Divider light />
                    
                    <ListItem>
                      <ListItemText
                        primary={<IntlMessages id="item.type" />}
                        primaryTypographyProps={{ color: "secondary" }}
                        secondary={
                          itemReview.type===1 ? <IntlMessages id={"book"} /> : <IntlMessages id={"article"} />
                        }
                      />
                    </ListItem>
                    <Divider light />
                
                { itemReview.type===2 &&
                    <ListItem>
                      <ListItemText
                        primary={<IntlMessages id="item.journalId" />}
                        primaryTypographyProps={{ color: "secondary" }}
                        secondary={
                          <IntlMessages id={"journal."+itemReview.journalId} /> 
                        }
                      />
                    </ListItem>}
                    <Divider light />
                  </List>

                </CardBox>

              
              </div>
            ) : (
              <div className="bg-grey"></div>
            )} 
   </div>
            <SweetAlert
              show={this.state.lock}
              input
              confirmBtnText={<IntlMessages id="button.ok" />}
              confirmBtnBsStyle="danger"
              title={<IntlMessages id="itemReviewCorrect.alert.title" />}
              validationMsg={<IntlMessages id="itemReviewCorrect.alert.msg" />}
              onConfirm={(text) => {
             //  //console.log("tettt ", text);
                this.getResultByCorrectCode(text)
               
              }}
              //  style={{backgroundColor:'red'}}
              hideOverlay={false}
               
            >


              <div className="row justify-content-center mb-3">
                <Link className="" to="/">
                  <img
                    src={require("assets/images/says_logo/sonLogo2.png")}
                    alt="Yaysis"
                    title="Sözlük ve Ansiklopedi Yönetim Sistemi"
                  />
                </Link>
              </div>

              {
                this.state.error && <Alert className="mb-2" severity="error">
<IntlMessages id="itemReviewCorrect.alert.error" />
                </Alert>
              }
            </SweetAlert>
{/* 
            <SweetAlert
              show={this.state.error}
              danger
              confirmBtnText={<IntlMessages id="button.ok" />}
              confirmBtnBsStyle="danger"
              title={<IntlMessages id="showItem.alert.error" />}
              onConfirm={() => {
                this.setState({error:false})
              }}
            
            /> */}
            

          </div>
 
  
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser } = auth;
  return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
  userSignIn,
  hideMessage,
  showAuthLoader,
})(ItemReviewCorrect);
